import { Button, cn, IconPlus } from '@newfront-insurance/core-ui/v2';
import type { ReactNode } from 'react';

import { novaGradientClass } from '../design-system';

export function SettingsPageHeader({
  title,
  titleId,
  description,
  action,
}: {
  title: string;
  titleId?: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <header className="flex w-full flex-wrap items-center justify-between gap-4 font-sans">
      <div className="min-w-0 flex-1 basis-40">
        <h2 id={titleId} className="text-steel-500 text-lg leading-6 font-normal">
          {title}
        </h2>
        <p className="text-steel-400 mt-1 text-sm leading-4">{description}</p>
      </div>
      {action ? <div className="ml-auto max-w-full">{action}</div> : null}
    </header>
  );
}

export function SettingsCreateButton({
  children,
  onClick,
  disabled,
  testId,
}: {
  children: string;
  onClick?: () => void;
  disabled?: boolean;
  testId?: string;
}) {
  return (
    <Button
      type="button"
      variant="transparent"
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      className={cn(
        'h-10 shrink-0 gap-2 rounded-full px-4 text-base leading-5 whitespace-nowrap',
        'text-wtw-ultraviolet-850 hover:text-wtw-ultraviolet-850',
        novaGradientClass.aiBackground,
      )}
    >
      <span aria-hidden="true">
        <IconPlus className="size-[18px]" />
      </span>
      {children}
    </Button>
  );
}
